import React, {useEffect, useState} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { useStore, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { useApp, useQuery } from '../../../../hooks/common'
import { Iconfont } from '../../../../components/icon/iconfont'
import MeLoading from '../../components/loading'
import { useDispatch } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import Header from "../../../policy/fragments/heading/index"
import { fetchGetMessage, fetchMessageGetList, surveyGet, surveySave } from '../../../../../api'
import SearchSelect from '../../components/search-select'
import { action_fect_countries } from '../../../../../store/actions/global'
import { BigButton } from '../../../../components/button'
import Skeleton from '../../components/skeleton/index';

const MaskBox = props => {
    useStyles(classes)
    const {reminderMessage, goShopping, viewPoints, Intl} = props

    return (
        <div className={classes.MaskBox}>
            <div className={classes.MaskInfo}>
                {
                    reminderMessage?
                    <div className={classes.MaskMesaage} dangerouslySetInnerHTML={{__html: reminderMessage}} style={{padding: '0 45px'}}></div>:
                    <React.Fragment></React.Fragment>
                }
                <div className={classes.MaskButton}>
                    <div className={classes.MaskBtn} onClick={() => goShopping()}>
                        <FormattedMessage id="shop_now" defaultMessage={'Shop Now'}/>
                    </div>
                    <div className={`${classes.MaskBtn} ${classes.View}`} onClick={() => viewPoints()}>
                        <FormattedMessage id="get_more_points" defaultMessage={'Get More Points'}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

const SurveyItem = props => {
    useStyles(classes)
    const {
        answerList,
        title,
        type,
        index,
        defaultV,
        inputValue,
        hadDoneBefore,
        content,
        noBorder,
        siteName,
        question,
        changeFunc,
        otherChangeFunc,
        countries
    } = props

    const [selectItem, setSelectItem] = useState('Country')

    const replacedSiteName = (title) =>{
        if(title){
            let text = title.replace(/(chicme|Chicme|Chic me|chic me|Chic Me|chic Me|ChicMe|chicMe)/g, ()=>{return siteName});
            return text
        }
        return ''
    }

    const optionClick = (item) => {
        if(!hadDoneBefore){
            setSelectItem(item?.label || 'Country')
            changeFunc({question: question, selectedValue: item?.value})
        }
    }

    const changeHandle = (e, type) => {
        if(!hadDoneBefore){
            if(type == 'textarea'){
                otherChangeFunc({question: question, selectedValue: e?.target?.value})
            } else {
                changeFunc({question: question, selectedValue: e?.target?.value})
            }
        }
    }

    const othersChange = (e) => {
        console.log("othersChange", e)
        if(!hadDoneBefore){
            otherChangeFunc({
                question: question,
                inputValue: e?.target?.value
            })
        }
    }

    return (
        <div className={`${classes.Question} ${!noBorder ? '': classes.LastChild}`} id={'question'+(question?.id)}>
            {
                title && type != 'title' ?
                <div className={classes.QuestionTitle}>
                    {replacedSiteName(title)}
                </div>:
                <React.Fragment></React.Fragment>
            }
            {
                type == 'radio' ?
                <div className={classes.QuestionAnswerList}>
                    {
                        answerList?.map((item, index) => (
                            <div key={item?.value + index} className={`${classes.Answer} ${defaultV == item?.value?classes.AnswerSelected:''}`}>
                                <label htmlFor={title+item?.value} >
                                    <div className={classes.AnswerContent}>{index + 1}. {item?.label || ''}</div>
                                    <div className={classes.AnswerSelect}>
                                        <Iconfont className={classes.AnswerSelectIcon}>&#xe638;</Iconfont>
                                    </div>
                                </label>
                                <input
                                    disabled={hadDoneBefore}
                                    type="radio"
                                    name={title}
                                    value={item.value}
                                    id={title+item?.value}
                                    onChange={(e) => changeHandle(e, 'input')}
                                    />
                                {
                                    item?.value == 'Others' && defaultV?.indexOf(item?.value) != -1 ?
                                    <div className={classes.checkboxTextArea} >
                                        <textarea
                                            disabled={hadDoneBefore}
                                            defaultValue={inputValue}
                                            onChange={(e) => othersChange(e)}></textarea>
                                    </div>:
                                    <React.Fragment></React.Fragment>
                                }
                            </div>
                        ))
                    }
                </div>:
                type == 'checkbox' ?
                <div className={classes.QuestionAnswerList}>
                    {
                        answerList?.map((item, index) => (
                            <div key={item?.value + index} className={`${classes.Answer} ${classes.AnswerCheckbox} ${defaultV?.indexOf(item?.value) != -1?classes.AnswerSelected:''}`}>
                                <label htmlFor={title+item?.value} >
                                    <div className={classes.AnswerContent}>{index + 1}. {item?.label || ''}</div>
                                    <div className={classes.AnswerSelect}>
                                        <Iconfont className={classes.AnswerSelectIcon}>&#xe638;</Iconfont>
                                    </div>
                                </label>
                                <input
                                    disabled={hadDoneBefore}
                                    type="checkbox"
                                    name={title}
                                    value={item.value}
                                    id={title+item?.value}
                                    onChange={(e) => changeHandle(e, 'input')}
                                    />
                                {
                                    item?.value == 'Others' && defaultV?.indexOf(item?.value) != -1 ?
                                    <div className={classes.checkboxTextArea} >
                                        <textarea
                                            disabled={hadDoneBefore}
                                            defaultValue={inputValue}
                                            onChange={(e) => othersChange(e)}></textarea>
                                    </div>:
                                    <React.Fragment></React.Fragment>
                                }
                            </div>
                        ))
                    }
                </div>:
                type == 'textarea' ?
                <div className={classes.QuestionAnswerList}>
                    <textarea
                        disabled={hadDoneBefore}
                        cols="30"
                        rows="10"
                        defaultValue={defaultV}
                        onChange={e => changeHandle(e,'textarea')}></textarea>
                </div>:
                type == 'select' ?
                <div className={classes.QuestionAnswerList}>
                    <SearchSelect
                        defaultV={selectItem}
                        type={'select'}
                        countries={countries}
                        optionClick={(item) => optionClick(item)}
                        />
                </div>:
                type == 'content' ?
                <div>
                    <div className={classes.SurveyInfo}>
                        <div className={classes.InfoBox}>
                            <div className={classes.InfoContent}>{replacedSiteName(content)}</div> 
                        </div>
                    </div>
                </div>:
                type == 'title'?
                <div>
                    <div className={classes.SurveyInfo}>
                        <div className={classes.InfoBox}>
                            <div className={classes.InfoTitle}>{replacedSiteName(title)}</div>
                            <div className={classes.InfoContent}>{replacedSiteName(content)}</div> 
                        </div>
                    </div>
                </div> :
                <React.Fragment></React.Fragment>
            }
        </div>
    )
}

const SurveyBox = props => {
    useStyles(classes)
    const { data, hadDoneBefore, sitName, changeFunc, otherChangeFunc, countries} = props

    return (
        <div className={`${classes.SurveyBox}` }>
            {
                data?.map((item, index) => (
                    <SurveyItem
                        key={item?.title?.split(' ')?.[-1]}
                        answerList={item?.answerList || []}
                        title={item?.title || ''}
                        type={item?.type || ''}
                        index={index}
                        defaultV={item?.defaultValue || ''}
                        inputValue={''}
                        hadDoneBefore={hadDoneBefore}
                        content={item?.content || ''}
                        noBorder={index == data?.length-1 || item?.noBorder}
                        siteName={sitName}
                        question={item}
                        changeFunc={(data) => changeFunc(data)}
                        otherChangeFunc={(data) => otherChangeFunc(data)}
                        countries={countries}
                        />
                ))
            }
        </div>
    )
}


const SurveyPage = props => {
    useStyles(classes)

    const global = useSelector(state => state.global)
    const pageCustomer = useSelector(state => state.pageCustomer)
    const { message } = pageCustomer || {}

    const dispatch = useDispatch()
    const Intl = useIntl()
    const history = useHistory()
    const isApp = useApp()

    const [loading, setLoading] = useState(true)
    const [surveyData, setSurveyData] = useState(null)
    const [hadDoneBefore, setHadDoneBefore] = useState(false)
    const [userId, setUserId] = useState('')
    const [maskData, setMaskData] = useState()
    const [maskShow, setMaskShow] = useState(false)
    const [countries, setCountries] = useState('')
    const [submitLoading, setSubmitLoading] = useState(false)

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
		}
    }, [])

    useEffect(async () => {
        if(!global?.countries || global?.countries?.length <= 0){
            const cs = await dispatch(action_fect_countries())
            setCountries(cs)
        } else {
            setCountries(global?.countries)
        }
        initSurvey()
    }, [])

    useEffect(() => {
        if(message){
            setLoading(false)
        } else {
            setTimeout(() => {
                setLoading(false)
            }, 5000)
        }
    },[message])

    const initSurvey = () => {
        let code = global?.config?.shortName?.toLocaleLowerCase() == 'bellewholesale' ? 'M1576': 'M1575'
        // console.log("init: ", global?.config?.shortName, global?.config?.shortName?.toLocaleLowerCase(), code)

        fetchGetMessage(code).then(res => {
            if(res?.code == 200 && res?.result?.message){
                setSurveyData(JSON.parse(res?.result?.message))
                getSurveyHistory()
            } else {
                setLoading(false)
                alert(res?.result || 'Survey init fail')
            }
        }).catch(err => {
            setLoading(false)
            alert(err?.result || 'Survey init fail')
        })
    }

    const getSurveyHistory = () => {
        surveyGet().then(res => {
            if(res?.code == 200 && res?.result){
                const { answers, id } = res?.result
                if(id){
                    setUserId(id)
                }
                if(answers){
                    setHadDoneBefore(true)
                    fetchGetMessage('M1628').then(res => {
                        if(res?.code == 200 && res?.result?.message){
                            setMaskData(res?.result?.message)
                            setLoading(false)
                        }
                    })
                }
            } else {
                setLoading(false)
            }
        }).catch(err => {
            setLoading(false)
            alert(err?.result || err)
        })
    }

    const changeFunc = (data) => {
        let list = [...surveyData]
        list?.forEach(l => {
            if(l?.id == data?.question?.id){
                const selectedQuestion = l
                if(selectedQuestion.type == 'radio' || selectedQuestion.type == 'textarea' || selectedQuestion.type == 'select'){
                    selectedQuestion.defaultValue = data?.selectedValue
                } else if(selectedQuestion.type == 'checkbox'){
                    if(Object.prototype.toString.call(selectedQuestion?.defaultValue) == '[object Array]'){
                        let index = selectedQuestion?.defaultValue?.indexOf(data?.selectedValue)
                        if(index!=-1){
                            selectedQuestion.defaultValue.splice(index,1)
                        } else {
                            selectedQuestion.defaultValue.push(data.selectedValue)
                        }
                    } else {
                        selectedQuestion.defaultValue = [data.selectedValue]
                    }
                }
            }
        })
        setSurveyData([...list])
    }

    const otherChangeFunc = (data) => {
        let list = [...surveyData]
        list?.forEach(l => {
            if(l?.id == data?.question?.id){
                l.inputValue = data?.selectedValue
            }
        })
        setSurveyData([...list])
    }

    const submitSurvey = () => {
        if(hadDoneBefore){
            return;
        }
        let list = []
        let params = {}
        let _this = this;
        surveyData?.forEach((s) => {
            let obj = {id:'',title:'',answer:'',input:''}
            if(s?.id || s?.id == 0){
                obj.id = s?.id
                obj.title = s?.title || ''
                obj.answer = s?.defaultValue || ''
                obj.inputValue = s?.inputValue || ''
                list.push(obj)
            }
        })
        params.answers = JSON.stringify(list)
        if(userId){
            params.id = userId
        }
        // console.log('submitSurvey',list, surveyData)
        if(checkData(list) && !submitLoading){
            setSubmitLoading(true)
            surveySave(params).then(res => {
                setSubmitLoading(false)
                if(res?.code == 200){
                    const {prompt} = res
                    // document.body.style.position = 'fixed'
                    if(res.code == 200){
                        setMaskShow(true)
                        if(prompt?.html){
                            let str = prompt.html;
                            if(window.isApp == "true"){
                                str = str.replace(/policy\/bonus-point/,"policy/bonus-point?isApp=1");
                            }
                            setMaskData(str)
                        }else{
                            fetchGetMessage('M1628').then(res => {
                                if(res?.message){
                                    setMaskData(res?.message)
                                }
                            })
                        }
                    }
                }
            }).catch(err => {
                alert(err?.result || err)
            })
        }
    }

    const checkData = (list) => {
        const emptyAnswer = list?.find(l =>
            (!l?.answer && !l?.inputValue) || JSON.stringify(l?.answer)=="[]" || JSON.stringify(l?.answer)=="{}")
        if(emptyAnswer){
            let dom = document.querySelector(`#question${emptyAnswer?.id || 0}`)
            dom.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
        return !emptyAnswer
    }

    return <div classes={classes.WalletPage}>
        <Header centerSlot={<FormattedMessage id="survey" defaultMessage={'Survey'}/>} />

        {
            maskData ?
            <MaskBox
                reminderMessage={maskData}
                Intl={Intl}
                goShopping={() => {
                    if(isApp){
                        window.location.href = 'chic-me://chic.me/home';
                        return
                    } else {
                        window.location.href = '/'
                        return
                    }
                }}
                viewPoints={() => {
                    if(isApp){
                        window.location.href = 'chic-me://chic.me/credits';
                        return
                    } else {
                        history.push('/user/credits')
                    }
                }}
            />:
            <React.Fragment>
                {
                    surveyData ? <React.Fragment>
                        <SurveyBox
                            data={surveyData}
                            countries={countries}
                            hadDoneBefore={hadDoneBefore}
                            sitName={global?.config?.shortName || 'chicme'}
                            changeFunc={data => changeFunc(data)}
                            otherChangeFunc={data => otherChangeFunc(data)}
                            />
                        <div className={classes.SignOutButton}>
                            <BigButton onClick={submitSurvey}><FormattedMessage id="submit" defaultMessage="Submit"/></BigButton>
                        </div>
                    </React.Fragment> : <React.Fragment>
                        <Skeleton />
                    </React.Fragment>
                }

            </React.Fragment>
        }

        <MeLoading loading={loading} />
    </div>
}

SurveyPage.fetchData = async (store, params, search, headers) => {
    // await store.dispatch(action_fetch_message('M1545',headers))
}

export default SurveyPage